import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { MPSType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/MPSType";
import { PerformanceMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PerformanceIncomeDataView } from "../../../../../../../../Wrap/Constants/Enums/Portfolio/Performance/PerformanceIncomeDataView";

export enum PerformanceDataView {
    Summary = "Summary",
    Detail = "Detail",
    RealisedGainLoss = "Realised gain / loss",
    UnrealisedGainLoss = "Unrealised gain / loss",
    Income = "Income",
    Charges = "Charges",
}

export const subAccountTypeMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.Npr]: "SIPP",
    [SubAccountType.CashIsa]: "Cash ISA",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.InvestmentAccount]: "Personal Portfolio",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Cash Account",
    [SubAccountType.CashAccount]: "Cash Account",
    [SubAccountType.OffshoreBond]: "Offshore Bond",
    [SubAccountType.OnshoreBond]: "Onshore Bond",
    [SubAccountType.NotSpecified]: "All",
};

export const IncomeTableViewMap = {
    [PerformanceIncomeDataView.Interest]: "Interest",
    [PerformanceIncomeDataView.AccumulationFundInterestNonCash]: "Accumulation fund interest (non cash)",
    [PerformanceIncomeDataView.Dividends]: "Dividends",
    [PerformanceIncomeDataView.AccumulationFundDistributionsNonCash]: "Accumulation fund distributions (non cash)",
    [PerformanceIncomeDataView.EquityDividends]: "Equity dividends",
    [PerformanceIncomeDataView.Tax]: "Tax",
};

export const AssetClassTypeArray = [AssetClassType.Tier1, AssetClassType.Tier2, AssetClassType.NoAssetClass];

export const MPSTypeArray = [MPSType.MPSSummary, MPSType.MPSDetails];

export const AssetClassTypeMap = {
    [AssetClassType.Tier1]: "Tier 1",
    [AssetClassType.Tier2]: "Tier 2",
    [AssetClassType.NoAssetClass]: "No tiers",
};

export const MPSTypeMap = {
    [MPSType.MPSSummary]: "MPS Summary",
    [MPSType.MPSDetails]: "MPS Detail",
};

export const returnTooltip = {
    title: {
        [PerformanceMethod.Simple]: `Simple return`,
        [PerformanceMethod.IRR]: `Internal rate of return ("IRR")`,
    },
    content: {
        [PerformanceMethod.Simple]: `This is a non-weighted measure to show the change in value of the investment in percentage terms. The "Change in Value" is divided by the amount invested over the period – i.e. by the opening value plus any money added in the period.`,
        [PerformanceMethod.IRR]: `This is the percentage (%) measure to show how investments have performed over the set reporting period.  It's calculated by dividing the monetary change in value by the time and value of the transactions that took place over the period. This figure is non-annualised.`,
    },
};

export const StarTooltip =
    "* Denotes an investment asset that has been re-registered on to the wrap platform. Historical transactional data is not captured prior to re-registration; therefore the realised and unrealised gain/loss figures for this asset should not be relied upon for tax return purposes.";
